import JSEncrypt from 'jsencrypt';

let publicKey: string | null = null;
const encryptor = new JSEncrypt();

export function setPublicKey(key: string) {
  publicKey = key;
  encryptor.setPublicKey(key);
}

export function hasPublicKey() { return !!publicKey; }

export function encryptString(value: string): string {
  const out = encryptor.encrypt(value);
  if (!out) throw new Error('encryption failed — no public key');
  return out;
}

export function encryptFields<T extends Record<string, string>>(obj: T): T {
  const out: Record<string, string> = {};
  for (const k of Object.keys(obj)) out[k] = encryptString(obj[k]);
  return out as T;
}
